export const SET_MODAL_VISIBILITY = 'SET_MODAL_VISIBILITY';
